<template>
  <div>
    <template v-if="url">
      <pdf-viewer-ui :src="url"/>
    </template>
  </div>
</template>

<script>
  import PdfViewerUi from "@/components/pdfViewer/PdfViewerUi";

  export default {
    name: "PdfReader",
    components: {
      PdfViewerUi,
    },
    data() {
      return {
        sourceId: this.$route.query.id,
        url: "",
      };
    },
    mounted() {
      if(this.sourceId && this.sourceId == 6397) {
        let url = window.config.basicServerHttpUrl + "#/product/material/list?id=26173";
        // const url = "http://10.167.38.94:7100/#/product/material/list?id=26173";
        window.location.href = url;
      } else {
        this.url = window.config.basicServerHttpUrl + "pans/downLoadFile?id=" + this.$route.query.id;
      }
    },
  };
</script>
<style lang="scss">
</style>